import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/medical-history/summaryReport";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	summaryReport: {
		id: "form.summary_report",
		defaultMessage: "Anamnézis"
	},
	description: {
		id: "form.summary_report.description",
		defaultMessage: "Szöveges összefoglaló"
	}
});

const fields: { [key: string]: FieldData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.description }] }]
};

export const node: LeafNode = {
	id: "summaryReport",
	value: {
		title: messages.summaryReport,
		validator,
		fieldset,
		applyCurrentDate: true,
		isImportant: true,
		defaults: [
			{
				path: ["description"],
				query: {
					interpretation: {
						vocab: "htx",
						code: "medical_history_summary"
					}
				}
			}
		]
	}
};
